<template lang="pug">
.truemed-wrapper
  #truemed-instructions(icon-height="12" data-public-id="tm_qual_pdz3vcpupd" data-allow-mismatch="attribute")
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'

useHead({
  script: [
    {
      src   : "https://static.truemed.com/widgets/rogue-pdp-widget.min.js",
      defer : true,
    },
  ],
})
</script>

<style lang="scss" scoped>
.truemed-wrapper {
  // Min height prevents CLS
  min-height: 35px;
  margin-top: $size-xs;
  margin-bottom: $size-s;
  font-size: $size-xs;
  font-family: $font-base;

  // Set css veriables that are used by the widget
  --truemed-text-color: #000000;
  --truemed-link-color: #1277B7;

  :deep(.truemed-instructions-open) {
    color: var(--truemed-link-color);
  }

  @media (min-width: 384px) {
    min-height: 17px;
  }
}
</style>
